import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import ViewMode from "@app/enum/dashboard/ViewMode";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import { TabbedDrillDownListFetcherPayload } from "@app/scene/dashboard/types/TabbedDrillDownListFetcher";
import EntityTypesSupportedInFrequencyDuringActivity from "@app/types/dashboard/cards/frequencyDuringActivity/EntityTypesSupportedInFrequencyDuringActivity";
import FrequencyDuringActivityCardConfiguration from "@app/types/dashboard/cards/frequencyDuringActivity/FrequencyDuringActivityCardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import MapViewportState from "@app/types/map/MapViewportState";

import FrequencyDuringActivityCardData from "./FrequencyDuringActivityCardData";

export const fetchFrequencyDuringActivityCardData = createAction(
  "@dashboard/fetchFrequencyDuringActivityCardData"
)<{
  callback: (data: FrequencyDuringActivityCardData) => void;
  configuration: FrequencyDuringActivityCardConfiguration;
  failureCallback?: () => void;
  offset?: number; // used with List view mode when we need to load more items
  scope?: Scope;
  viewMode: ViewMode;
  viewport?: MapViewportState; // used with Map view mode when user pans/zooms
}>();

export const showFrequencyDuringActivityDrillDown = createAsyncAction(
  "@dashboard/showFrequencyDuringActivityCardDrillDownModal/request",
  "@dashboard/showFrequencyDuringActivityCardDrillDownModal/success",
  "@dashboard/showFrequencyDuringActivityCardDrillDownModal/failure"
)<
  {
    configuration: FrequencyDuringActivityCardConfiguration;
    scope: Scope;
  },
  { viewStates: Record<EntityTypesSupportedInFrequencyDuringActivity, DrillDownViewState> },
  unknown
>();

export const hideFrequencyDuringActivityDrillDown = createAction(
  "@dashboard/hideFrequencyDuringActivityCardDrillDownModal"
)<void>();

export const fetchFrequencyDuringActivityCardDrillDownData = createAsyncAction(
  "@dashboard/fetchFrequencyDuringActivityCardDrillDownData/request",
  "@dashboard/fetchFrequencyDuringActivityCardDrillDownData/success",
  "@dashboard/fetchFrequencyDuringActivityCardDrillDownData/failure"
)<
  TabbedDrillDownListFetcherPayload<AnyEntity, EntityTypesSupportedInFrequencyDuringActivity>,
  {
    entityType: EntityTypesSupportedInFrequencyDuringActivity;
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyFrequencyDuringActivityDrillDownListViewSettings = createAction(
  "@dashboard/applyFrequencyDuringActivityDrillDownListViewSettings"
)<Partial<DrillDownViewState> & { entityType: EntityTypesSupportedInFrequencyDuringActivity }>();

export const exportFrequencyDuringActivityCardDrillDownData = createAction(
  "@dashboard/exportFrequencyDuringActivityCardData"
)<{
  configuration: FrequencyDuringActivityCardConfiguration;
  entityType: EntityTypesSupportedInFrequencyDuringActivity;
  scope: Scope;
}>();

export type FrequencyDuringActivityCardActions = ActionType<
  | typeof applyFrequencyDuringActivityDrillDownListViewSettings
  | typeof exportFrequencyDuringActivityCardDrillDownData
  | typeof fetchFrequencyDuringActivityCardData
  | typeof fetchFrequencyDuringActivityCardDrillDownData
  | typeof hideFrequencyDuringActivityDrillDown
  | typeof showFrequencyDuringActivityDrillDown
>;
